import { MatDialogRef } from '@angular/material/dialog';
import {
  componentWrapperDecorator,
  type Decorator,
  moduleMetadata,
} from '@storybook/angular';

/**
 * Reproduces the container Material renders a dialog into.
 *
 * `mat-dialog-title`, `mat-dialog-content` and `mat-dialog-actions` are all
 * styled as descendants of `.mat-mdc-dialog-container`, so a dialog component
 * rendered as a bare story loses its padding, title typography and action
 * alignment. Storybook has no overlay for the real container to attach to, so
 * the story is wrapped in the same structure instead.
 */
export function decorateDialog(): Decorator[] {
  return [
    moduleMetadata({
      providers: [
        {
          provide: MatDialogRef,
          useValue: {
            close: (): void => undefined,
            afterClosed: () => undefined,
            backdropClick: () => undefined,
          },
        },
      ],
    }),
    componentWrapperDecorator(
      (story) => `
        <div class="mat-mdc-dialog-container mdc-dialog mdc-dialog--open">
          <div class="mat-mdc-dialog-inner-container mdc-dialog__container">
            <div class="mat-mdc-dialog-surface mdc-dialog__surface">
              ${story}
            </div>
          </div>
        </div>
      `
    ),
  ];
}
